/**
 * filterPlural(['стол', 'стола', 'столов'], 11)
 * curry
 *  this.curry = filterPlural.bind(null, ['стол', 'стола', 'столов'])
 *  this.curry(1)
 *  this.curry(5)
 *
 * @param {Array<string>} titles
 * @param {number} number
 * @returns {string}
 */
const filterPlural = (titles, number) => {
  const cases = [2, 0, 1, 1, 1, 2];
  const titleIndex =
    number % 100 > 4 && number % 100 < 20
      ? 2
      : cases[number % 10 < 5 ? number % 10 : 5];
  return titles[titleIndex] || titles[titles.length - 1];
};

export default filterPlural;
